import { observer } from 'mobx-react-lite';
import React, { useContext, useState } from 'react';
import { Button, Header, Icon, Message, Modal, Segment } from 'semantic-ui-react';

import { formatDetailsDisp } from '../../../app/common/util/util';
import { RootStoreContext } from '../../../app/stores/rootStore';

const ReservationDetails: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { submitting, reservation, deleteReservation } = rootStore.reservationStore;
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Segment>
      {reservation?.startTime1 !== null && (
        <Message negative>
          <Icon name="exclamation" />
          使用済み
        </Message>
      )}
      <Header as="h4" attached="top" block size="small">
        来塔希望日
      </Header>
      <Segment attached size="small">
        {reservation?.reservationDate && formatDetailsDisp(new Date(reservation?.reservationDate))}
      </Segment>
      <Header as="h4" attached block size="small">
        来塔希望時間
      </Header>
      <Segment attached size="small">
        {reservation?.schedule}
      </Segment>
      <Header as="h4" attached block size="small">
        お名前（カタカナ）
      </Header>
      <Segment attached="bottom" size="small">
        {reservation?.reservationPerson}
      </Segment>
      <Modal
        trigger={
          <Button
            content="キャンセル"
            negative
            fluid
            disabled={reservation?.startTime1 !== null}
            onClick={() => setModalOpen(true)}
          />
        }
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        basic
        size="small"
      >
        <Modal.Content>
          <h3>本当にキャンセルしますか？</h3>
        </Modal.Content>
        <Modal.Actions>
          <Button
            basic
            color="green"
            inverted
            floated="right"
            loading={submitting}
            onClick={() => {
              deleteReservation().then(() => setModalOpen(false));
            }}
          >
            <Icon name="checkmark" />
            はい
          </Button>
          <Button color="red" inverted onClick={() => setModalOpen(false)}>
            <Icon name="remove" />
            いいえ
          </Button>
        </Modal.Actions>
      </Modal>
    </Segment>
  );
};

export default observer(ReservationDetails);
